// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_atlas_bikelanes_plus_routes: MapboxStyleLayer[] = [
  {
    layout: {
      'line-join': 'round',
    },
    type: 'line',
    id: 'route',
    paint: {
      'line-color': [
        'case',
        ['match', ['get', 'network'], ['lcn'], true, false],
        'rgba(51, 186, 240, 0.54)',
        ['match', ['get', 'network'], ['ncn', 'icn'], true, false],
        'rgba(51, 240, 92, 0.85)',
        ['match', ['get', 'network'], ['rcn'], true, false],
        'rgba(51, 117, 240, 0.54)',
        '#858585',
      ],
      'line-width': ['interpolate', ['linear'], ['zoom'], 8, 3, 18, 20],
      'line-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        ['match', ['get', 'network'], ['ncn'], 0.9, 0],
        8.5,
        ['match', ['get', 'network'], ['ncn', 'rcn'], 0.8, 0],
        9,
        ['match', ['get', 'network'], ['ncn', 'rcn'], 0.8, 0],
        10,
        0.4,
      ],
      'line-blur': 1,
    },
  },
  {
    layout: {
      'line-join': 'round',
      'line-cap': 'round',
    },
    type: 'line',
    id: 'RSV',
    paint: {
      'line-width': ['interpolate', ['linear'], ['zoom'], 5, 4, 8, 5, 18, 25],
      'line-opacity': ['interpolate', ['linear'], ['zoom'], 9, 1, 12, 0.4],
      'line-blur': 1,
      'line-color': '#fabd05',
    },
    filter: ['match', ['get', 'cycle_highway'], ['yes'], true, false],
  },
  {
    layout: {
      'text-size': 10,
      'icon-image': [
        'match',
        ['get', 'network'],
        ['ncn'],
        'jp-expressway-2',
        ['icn', 'rcn'],
        'rectangle-blue-2',
        '',
      ],
      'text-transform': 'uppercase',
      'symbol-spacing': 700,
      'text-font': ['Open Sans Bold', 'Arial Unicode MS Regular'],
      'symbol-placement': 'line',
      'icon-size': 1.5,
      'text-field': ['to-string', ['get', 'ref']],
      'text-letter-spacing': -0.02,
      'icon-padding': 6,
    },
    filter: ['has', 'ref'],
    type: 'symbol',
    id: 'sign_label',
    paint: {
      'text-color': '#c7efff',
      'icon-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        ['match', ['get', 'network'], ['ncn'], 1, 0],
        9.4,
        ['match', ['get', 'network'], ['ncn'], 1, 0],
        9.5,
        1,
      ],
      'text-opacity': [
        'interpolate',
        ['linear'],
        ['zoom'],
        8,
        ['match', ['get', 'network'], ['ncn'], 1, 0],
        9.4,
        ['match', ['get', 'network'], ['ncn'], 1, 0],
        9.5,
        1,
      ],
    },
  },
]
